import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { Link } from 'react-router-dom';

interface PastQuiz {
  id: string;
  date: string;
}

interface QuizPastQuizzesProps {
  pastQuizzes: PastQuiz[];
}

const QuizPastQuizzes: React.FC<QuizPastQuizzesProps> = ({ pastQuizzes }) => (
  <>
    <Typography
      variant="h6"
      sx={{
        fontFamily: '"Baloo 2", Arial, sans-serif',
        fontWeight: 600,
        color: 'primary.main',
        mt: 4,
        mb: 1,
      }}
    >
      Missed a past quiz?
    </Typography>
    <Box
      sx={{
        width: '100%',
        maxWidth: 340,
        mx: 'auto',
        background: '#fffbe6',
        border: '2px solid #ffd6e0',
        borderRadius: 4,
        p: 2,
        mb: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {pastQuizzes.length === 0 ? (
        <Typography color="text.secondary" sx={{ textAlign: 'center', fontFamily: '"Baloo 2", Arial, sans-serif' }}>
          No past quizzes yet!
        </Typography>
      ) : (
        pastQuizzes.map((quiz, idx) => (
          <React.Fragment key={quiz.id}>
            <Typography
              variant="subtitle1"
              component={Link}
              to={`/quiz/${quiz.id}`}
              sx={{
                fontFamily: '"Baloo 2", Arial, sans-serif',
                fontWeight: 600,
                color: '#800020',
                textAlign: 'center',
                textDecoration: 'none',
                p: 1,
                borderRadius: 2,
                width: '100%',
                transition: 'background 0.2s',
                '&:hover': {
                  background: '#ffe5b4',
                },
                mb: 0.5,
                display: 'block',
              }}
            >
              {quiz.date}
            </Typography>
            {idx < pastQuizzes.length - 1 && (
              <Divider
                sx={{
                  my: 1,
                  width: '60%',
                  mx: 'auto',
                  borderColor: '#ffd6e0',
                }}
              />
            )}
          </React.Fragment>
        ))
      )}
    </Box>
  </>
);

export default QuizPastQuizzes;